import * as React from 'react';
import { Link } from "react-router-dom";
import { ChevronDown20Regular, ChevronUp20Regular, Open20Regular } from '@fluentui/react-icons';
import { NavItem, NavLink } from 'reactstrap';
import { MATCHING_ENGINE, MEMBERS_PORTAL } from "../../accounts/Consts";
import { ILookupDictionary } from '../../lookup/types/ILookupDictionary';
import {
    ALL_REGISTERED_CUE_SHEET_PAGE,
    ALL_REGISTERED_WORKS_PAGE,
    CLAIMS_HISTORY_PAGE,
    DRAFT_AGREEMENTS_PAGE,
    DRAFT_SET_LISTS_PAGE,
    DRAFT_WORKS_PAGE,
    LIVE_PERFORMANCE_SUBMISSION_PAGE,
    MEMBER_STATEMENTS_PAGE,
    MY_DRAFT_CUE_SHEET_PAGE,
    MY_REGISTERED_CUE_SHEET_PAGE,
    PAGE_ANCHOR_MY_CASES,
    REGISTERED_AGREEMENTS_PAGE,
    REGISTERED_SET_LISTS_PAGE,
    REGISTERED_WORKS_PAGE,
    UNPAID_CLAIMS_PAGE,
    UPLOAD_CUE_SHEET_PAGE
} from '../../membersportal/Consts';
import { MenuIcon } from './icons/MenuIcon';
import { FormatFields } from '../../redux/types/FormatFields';
import { IEnableModulesConfigurationParametersItem } from '../../redux/types/IEnableModulesConfigurationParameterItem';
import IMembersPortalComponentDataItem from '../../redux/types/IMembersPortalComponentDataItem';
import { ITabReduxItem } from '../../redux/types/ITabReduxItem';
import { getDataAction } from '../../repertoire/components/toolBar/ToolbarHelper';
import { CONFIGURATION_PARAMETER_FIELD_FORMAT_KEY, WORK_MAINTENANCE_GROUP } from '../../repertoire/ConfigurationConsts';
import {
    ADJUSTMENTS_PAGE,
    AGREEMENTS_PAGE,
    ARTISTS_PAGE,
    CLAIMS_PAGE,
    DISTRIBUTIONS_PAGE,
    EMPTY_STRING_VALUE,
    FINDUSAGE_PAGE,
    IPS_PAGE,
    LICENSE_PAGE,
    PAYMENTRUN_PAGE,
    PRODUCTS_PAGE,
    USAGE_POOLS_PAGE,
    WORKFLOW_PAGE,
    WORKFLOW_PAGE_TOOLBAR,
    WORKS_PAGE
} from '../../repertoire/Consts';
import { SearchRequests } from '../../repertoire/services/SearchRequests';
import { If } from '../components/If';
import { IMenuItem } from '../types/IMenuItem';
import { handlePageAnchorNavigation, setPageAnchorTarget } from '../../util/tools';

interface IMenuProps {
    items: IMenuItem[];
    updateHeader: (menuItem: IMenuItem) => void;
    enabledModules: IEnableModulesConfigurationParametersItem[]
    addTab: (tab: ITabReduxItem) => void;
    isMembersPortal?: boolean;
    customer: string;
    lookups: ILookupDictionary;
    currentUserNameNumber: string;
    addWork: (lookups: ILookupDictionary, currentUserNumber: string, formats: any) => void;
    addSetLists: (lookups: ILookupDictionary, currentUserNumber: string) => void;
    addAgreements: (
        lookups: ILookupDictionary,
        currentUserNumber: string,
        isNew?: boolean,
        draftAgreementMaintenanceGeneralDataViewData?: IMembersPortalComponentDataItem
    ) => void;
    addLivePerformance: (
        lookups: ILookupDictionary,
        isNew?: boolean,
        livePerformanceMaintenanceGeneralDataViewData?: IMembersPortalComponentDataItem,
        formats?: FormatFields[],
        distributionCode?: string,
        currentUserNameNumber?: string
    ) => void;
    uploadCueSheets: (currentUserNumber: string) => void;
    className?: string;
    renderAsMobileAccordion?: boolean;
    expandedSection?: string | null;
    toggleSection?: (sectionName: string) => void;
}

export class Menu extends React.Component<IMenuProps> {
    constructor(props: IMenuProps) {
        super(props);
    }

    onClick(item: IMenuItem, e?: any) {
        const { addTab, addWork, addSetLists, addAgreements, currentUserNameNumber, lookups, addLivePerformance, uploadCueSheets } = this.props;
        this.props.updateHeader(item);

        const currentPath = window && window.location && window.location.pathname ? window.location.pathname : '';
        const itemBasePath = item && item.link && item.link.split('/').length > 1 ? `/${item.link.split('/')[1]}` : '';
        const isOnItemBaseRoute = !!(itemBasePath && currentPath.startsWith(itemBasePath));

        if (item && item.portalType === MEMBERS_PORTAL && !isOnItemBaseRoute && item.name !== 'memberStatementsSearch' && item.name !== 'myCases' && item.name !== 'cases') {
            return;
        }

        const META_DATA_KEY: any = {
            'works': { 'tab': WORKS_PAGE, instance: MATCHING_ENGINE },
            'agreements': { 'tab': AGREEMENTS_PAGE, instance: MATCHING_ENGINE },
            'ips': { 'tab': IPS_PAGE, instance: MATCHING_ENGINE },
            'artists': { 'tab': ARTISTS_PAGE, instance: MATCHING_ENGINE },
            'products': { 'tab': PRODUCTS_PAGE, instance: MATCHING_ENGINE },
            'workflows': { 'tab': WORKFLOW_PAGE, instance: MATCHING_ENGINE },
            'usages': { 'tab': FINDUSAGE_PAGE, instance: MATCHING_ENGINE },
            'pools': { 'tab': USAGE_POOLS_PAGE, instance: MATCHING_ENGINE },
            'claims': { 'tab': CLAIMS_PAGE, instance: MATCHING_ENGINE },
            'distributions': { 'tab': DISTRIBUTIONS_PAGE, instance: MATCHING_ENGINE },
            'paymentRuns': { 'tab': PAYMENTRUN_PAGE, instance: MATCHING_ENGINE },
            'licenses': { 'tab': LICENSE_PAGE, instance: MATCHING_ENGINE },
            'adjustments': { 'tab': ADJUSTMENTS_PAGE, instance: MATCHING_ENGINE },

            'draftWorks': { 'tab': DRAFT_WORKS_PAGE, instance: MEMBERS_PORTAL },
            'myRegisteredWorks': { 'tab': REGISTERED_WORKS_PAGE, instance: MEMBERS_PORTAL },
            'allRegisteredWorks': { 'tab': ALL_REGISTERED_WORKS_PAGE, instance: MEMBERS_PORTAL },
            'draftAgreements': { 'tab': DRAFT_AGREEMENTS_PAGE, instance: MEMBERS_PORTAL },
            'myRegisteredAgreement': { 'tab': REGISTERED_AGREEMENTS_PAGE, instance: MEMBERS_PORTAL },
            'memberStatementsSearch': { 'tab': MEMBER_STATEMENTS_PAGE, instance: MEMBERS_PORTAL },
            'draftSetLists': { 'tab': DRAFT_SET_LISTS_PAGE, instance: MEMBERS_PORTAL },
            'registeredSetLists': { 'tab': REGISTERED_SET_LISTS_PAGE, instance: MEMBERS_PORTAL },
            'livePerformanceSubmission': { 'tab': LIVE_PERFORMANCE_SUBMISSION_PAGE, instance: MEMBERS_PORTAL },
            'unpaidClaimsMembers': { 'tab': UNPAID_CLAIMS_PAGE, instance: MEMBERS_PORTAL },
            'claimsHistory': { 'tab': CLAIMS_HISTORY_PAGE, instance: MEMBERS_PORTAL },
            'membersPortalMyRegisteredCueSheets': { 'tab': MY_REGISTERED_CUE_SHEET_PAGE, instance: MEMBERS_PORTAL },
            'membersPortalAllRegisteredCueSheets': { 'tab': ALL_REGISTERED_CUE_SHEET_PAGE, instance: MEMBERS_PORTAL },
            'membersPortalMyDraftCueSheets': { 'tab': MY_DRAFT_CUE_SHEET_PAGE, instance: MEMBERS_PORTAL },
            'membersPortalUploadCueSheets': { 'tab': UPLOAD_CUE_SHEET_PAGE, instance: MEMBERS_PORTAL },
        }

        if (item.name === 'registerNewWork') {
            if (item && item.portalType === MEMBERS_PORTAL && isOnItemBaseRoute && e && e.preventDefault) {
                e.preventDefault();
            }
            SearchRequests.getConfigurationParameter(CONFIGURATION_PARAMETER_FIELD_FORMAT_KEY, WORK_MAINTENANCE_GROUP)
                .then(formats => {
                    addWork(lookups, currentUserNameNumber, formats);
                });
            return;
        }
        else if (item.name === 'registerNewAgreement') {
            if (item && item.portalType === MEMBERS_PORTAL && isOnItemBaseRoute && e && e.preventDefault) {
                e.preventDefault();
            }
            addAgreements(lookups, currentUserNameNumber, true, undefined);
            return;
        }
        else if (item.name === 'registerNewSetLists') {
            if (item && item.portalType === MEMBERS_PORTAL && isOnItemBaseRoute && e && e.preventDefault) {
                e.preventDefault();
            }
            addSetLists(lookups, currentUserNameNumber);
            return;
        }
        else if (item.name === 'submitNewLivePerformance') {
            if (item && item.portalType === MEMBERS_PORTAL && isOnItemBaseRoute && e && e.preventDefault) {
                e.preventDefault();
            }
            addLivePerformance(lookups, true, null, null, "", currentUserNameNumber);
            return;
        }
        else if (item.name === 'uploadCueSheets') {
            if (item && item.portalType === MEMBERS_PORTAL && isOnItemBaseRoute && e && e.preventDefault) {
                e.preventDefault();
            }
            uploadCueSheets(currentUserNameNumber);
            return;
        }
        else if (item.name === 'myCases' || item.name === 'cases') {
            e?.preventDefault?.();

            setPageAnchorTarget({
                path: '/',
                anchor: PAGE_ANCHOR_MY_CASES
            });

            if (window.location.pathname !== '/') {
                window.history.pushState({}, "", "/");
                window.dispatchEvent(new PopStateEvent("popstate"));
                return;
            }

            handlePageAnchorNavigation();
            return;
        }
        else {
            const newTab = META_DATA_KEY[item.name];
            const isWorkflow = item.name === 'workflows';

            if (!newTab || newTab.instance !== item.portalType) return;

            if (isWorkflow) {
                newTab.tab.dataActionToolbar = getDataAction(EMPTY_STRING_VALUE, WORKFLOW_PAGE_TOOLBAR);
            }

            addTab(newTab.tab);
        }
    }

    renderMenuItem(item: IMenuItem, key: number): JSX.Element {
        const { enabledModules } = this.props;

        let filteredItem: IMenuItem = item;
        const disableModules = enabledModules && enabledModules.length > 0 ?
            enabledModules.filter(x => !x.enable) : [];

        let hasDisabledModulesAndItemChildren = disableModules && disableModules.length > 0 && filteredItem.children.length > 0;

        filteredItem.children = hasDisabledModulesAndItemChildren ?
            item.children.filter((current) => disableModules.findIndex(x => x.link === current.link) === -1 ? current : null) :
            filteredItem.children;

        const isDisabled = !filteredItem.isEnabled;
        const hasChildren = filteredItem.children && filteredItem.children.length > 0;

        if (hasChildren) {
            // Dropdown menu item
            return (
                <NavItem className={`dropdown${isDisabled ? " disabled" : ""}`} key={key}>
                    <NavLink
                        tag={isDisabled ? undefined : Link}
                        className="dropdown-toggle"
                        to={isDisabled ? undefined : filteredItem.link}
                        onClick={isDisabled ? undefined : (e) => this.onClick(filteredItem, e)}
                        disabled={isDisabled}
                        tabIndex={isDisabled ? -1 : 0}
                        aria-disabled={isDisabled}
                        data-testid={`header-navigation-${filteredItem.name}-link`}
                    >
                        <MenuIcon iconKey={filteredItem.icon} />
                        {" " + filteredItem.label + " "}
                        <b className="caret"></b>
                    </NavLink>
                    <ul className="dropdown-menu">
                        {
                            filteredItem.children.map((c: IMenuItem, idx: number) =>
                                <NavItem key={idx}>
                                    {
                                        c.link && (c.link.startsWith('http://') || c.link.startsWith('https://')) ? (
                                            <a href={c.link} target="_blank" rel="noopener noreferrer" data-testid={`header-navigation-${filteredItem.name}-${c.name}-link`}>
                                                {c.label}
                                            </a>
                                        ) : (
                                            <NavLink
                                                tag={c.isEnabled ? Link : undefined}
                                                to={
                                                    c.isEnabled
                                                        ? c.link === "/cases/openNewCase"
                                                            ? { pathname: "/cases/openNewCase", aboutProps: { type: "new" } }
                                                            : c.link
                                                        : undefined
                                                }
                                                onClick={c.isEnabled ? (e) => this.onClick(c, e) : undefined}
                                                disabled={!c.isEnabled}
                                                tabIndex={c.isEnabled ? 0 : -1}
                                                aria-disabled={!c.isEnabled}
                                                className={c.isEnabled ? "" : "disabled"}
                                                data-testid={`header-navigation-${filteredItem.name}-${c.name}-link`}
                                            >
                                                {c.label}
                                            </NavLink>
                                        )
                                    }
                                </NavItem>
                            )
                        }
                    </ul>
                </NavItem>
            );
        }
        else {
            // Simple menu item (no dropdown)
            return (
                <NavItem key={key} className={isDisabled ? "disabled" : ""}>
                    <NavLink
                        tag={!isDisabled ? Link : undefined}
                        to={!isDisabled ? filteredItem.link : undefined}
                        onClick={!isDisabled ? (e) => this.onClick(filteredItem, e) : undefined}
                        disabled={isDisabled}
                        tabIndex={isDisabled ? -1 : 0}
                        aria-disabled={isDisabled}
                        className={isDisabled ? "disabled" : ""}
                        data-testid={`header-navigation-${filteredItem.name}-link`}
                    >
                        <MenuIcon iconKey={filteredItem.icon} />
                        {" " + filteredItem.label + " "}
                    </NavLink>
                </NavItem>

            );
        }
    }

    renderMobileMenuItem(item: IMenuItem, key: number): JSX.Element {
        const { enabledModules, expandedSection, toggleSection } = this.props;

        let filteredItem: IMenuItem = item;
        const disableModules = enabledModules && enabledModules.length > 0 ?
            enabledModules.filter(x => !x.enable) : [];

        let hasDisabledModulesAndItemChildren = disableModules && disableModules.length > 0 && filteredItem.children.length > 0;

        filteredItem.children = hasDisabledModulesAndItemChildren ?
            item.children.filter((current) => disableModules.findIndex(x => x.link === current.link) === -1 ? current : null) :
            filteredItem.children;

        const isDisabled = !filteredItem.isEnabled;
        const hasChildren = filteredItem.children && filteredItem.children.length > 0;
        const isExpanded = !isDisabled && expandedSection === filteredItem.name;

        if (hasChildren) {
            return (
                <li className={`mobileMenuSection${isExpanded ? " expanded" : ""}${isDisabled ? " disabled" : ""}`} key={key}>
                    <button
                        type="button"
                        className="mobileMenuSectionHeader"
                        onClick={isDisabled ? undefined : () => toggleSection?.(filteredItem.name)}
                        disabled={isDisabled}
                        aria-disabled={isDisabled}
                        aria-expanded={isExpanded}
                        data-testid={`header-mobile-navigation-${filteredItem.name}-button`}
                    >
                        <span className="mobileMenuSectionLabel">
                            <MenuIcon iconKey={filteredItem.icon} />
                            <span>{filteredItem.label}</span>
                        </span>
                        {isExpanded ?
                            <ChevronUp20Regular className="mobileMenuChevron" aria-hidden="true" /> :
                            <ChevronDown20Regular className="mobileMenuChevron" aria-hidden="true" />
                        }
                    </button>
                    {isExpanded &&
                        <ul className="mobileMenuSectionContent">
                            {
                                filteredItem.children.map((c: IMenuItem, idx: number) =>
                                    <NavItem key={idx}>
                                        {
                                            c.link && (c.link.startsWith('http://') || c.link.startsWith('https://')) ? (
                                                <a href={c.link} target="_blank" rel="noopener noreferrer" data-testid={`header-mobile-navigation-${filteredItem.name}-${c.name}-link`}>
                                                    {c.label}
                                                </a>
                                            ) : (
                                                <NavLink
                                                    tag={c.isEnabled ? Link : undefined}
                                                    to={
                                                        c.isEnabled
                                                            ? c.link === "/cases/openNewCase"
                                                                ? { pathname: "/cases/openNewCase", aboutProps: { type: "new" } }
                                                                : c.link
                                                            : undefined
                                                    }
                                                    onClick={c.isEnabled ? (e) => this.onClick(c, e) : undefined}
                                                    disabled={!c.isEnabled}
                                                    tabIndex={c.isEnabled ? 0 : -1}
                                                    aria-disabled={!c.isEnabled}
                                                    className={c.isEnabled ? "" : "disabled"}
                                                    data-testid={`header-mobile-navigation-${filteredItem.name}-${c.name}-link`}
                                                >
                                                    {c.label}
                                                </NavLink>
                                            )
                                        }
                                    </NavItem>
                                )
                            }
                        </ul>
                    }
                </li>
            );
        }
        else {
            return (
                <NavItem key={key} className={`mobileMenuSection mobileMenuSingleItem${isDisabled ? " disabled" : ""}`}>
                    <NavLink
                        tag={!isDisabled ? Link : undefined}
                        to={!isDisabled ? filteredItem.link : undefined}
                        onClick={!isDisabled ? (e) => this.onClick(filteredItem, e) : undefined}
                        disabled={isDisabled}
                        tabIndex={isDisabled ? -1 : 0}
                        aria-disabled={isDisabled}
                        className={isDisabled ? "disabled" : "mobileMenuSectionHeader"}
                        data-testid={`header-mobile-navigation-${filteredItem.name}-link`}
                    >
                        <span className="mobileMenuSectionLabel">
                            <MenuIcon iconKey={filteredItem.icon} />
                            <span>{filteredItem.label}</span>
                        </span>
                    </NavLink>
                </NavItem>
            );
        }
    }

    renderRAStatmentLink(): JSX.Element {
        const RA_STATEMENT = 'RA Statement';
        const RA_LINK = 'https://www.robsav.com/Account-Login'

        return (
            <li className="dropdown nav-item">
                <a href={`${RA_LINK}`} className="dropdown-toggle nav-link" target="_blank" rel="noopener noreferrer" data-testid="header-navigation-ra-statement-link">
                    <Open20Regular className="icon" aria-hidden="true" focusable="false" />
                    {` ${RA_STATEMENT} `}
                </a>
            </li>
        )

    }

    renderMenuItems(items: IMenuItem[]): JSX.Element[] {
        if (items && items.length > 0) {
            return items.map((i: IMenuItem, idx: number) => this.renderMenuItem(i, idx));
        }
        else {
            return null;
        }
    }

    renderMobileMenuItems(items: IMenuItem[]): JSX.Element[] {
        if (items && items.length > 0) {
            return items.map((i: IMenuItem, idx: number) => this.renderMobileMenuItem(i, idx));
        }
        else {
            return null;
        }
    }

    render() {
        const { customer, className, renderAsMobileAccordion } = this.props

        if (renderAsMobileAccordion) {
            return (
                <ul className="mobileMenuSections">
                    {this.renderMobileMenuItems(this.props.items)}
                </ul>
            );
        }

        return (
            <ul className={className ? `nav navbar-nav ${className}` : "nav navbar-nav"}>
                {this.renderMenuItems(this.props.items)}
            </ul>
        );
    }
}